import AppFooter from './AppFooter'
export * from './AppFooter'

export default AppFooter
